export { default as GlobalModalsRegistrar, ModalSkeleton } from './GlobalModalsRegistrar/GlobalModalsRegistrar'
